/**
 * Attachment lookup spanning event, booking and stay links.
 */

import type { Attachment, TripDocument } from "./schema.ts";

export function filesFor(trip: TripDocument, ...entityIds: Array<string | null | undefined>): Attachment[] {
  const ids = new Set(entityIds.filter((id): id is string => Boolean(id)));
  for (const booking of trip.bookings) {
    if (ids.has(booking.id) || (booking.stayId && ids.has(booking.stayId))) ids.add(booking.id);
  }
  for (const event of trip.events) {
    if (event.bookingId && ids.has(event.id)) ids.add(event.bookingId);
    if (event.bookingId && ids.has(event.bookingId)) ids.add(event.id);
  }
  return trip.attachments.filter((file) => {
    if (file.linkedEntityIds.some((id) => ids.has(id))) return true;
    return trip.bookings.some((booking) => ids.has(booking.id) && booking.attachmentIds.includes(file.id));
  });
}
